import React from "react";
import {
  Box,
  Image,
  Text,
  Flex,
  Center,
} from "@chakra-ui/react";
import SylvrVideo from "../assets/images/SylvrVideo.JPG";

const VideoSection = () => {
  const handleOpen = () => {
    window.open(
      "https://embed.app.guidde.com/playbooks/r3ra7qMbEVNNcBdMwBtENx",
      "_blank"
    );
  };

  return (
    <Box
      w="full"
      mt="32"
      mb="20"
      px="6"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {/* Clickable Video Container */}
      <Box
        onClick={handleOpen}
        cursor="pointer"
        w="full"
        maxW="6xl"
        bg="white"
        rounded="3xl"
        p="6"
        position="relative"
        transition="all 0.2s"
        boxShadow="0px 20px 40px rgba(0,0,0,0.06)"
        _hover={{ transform: "scale(1.01)" }}
      >
        {/* Video Thumbnail Wrapper */}
        <Flex
          w="full"
          h="420px"
          rounded="2xl"
          overflow="hidden"
          position="relative"
          bgGradient="linear(to-br, gray.100, gray.200)"
          align="center"
          justify="center"
        >
          {/* Background Image */}
          <Image
            src={SylvrVideo}
            alt="Video Thumbnail"
            position="absolute"
            w="full"
            h="full"
            objectFit="cover"
            opacity="0.6"
          />

          {/* Play Button */}
          <Center
            // zIndex="10"
            bg="rgba(245, 245, 245, 0.8)"
            p="6"
            rounded="full"
            boxShadow="lg"
            mt='55px'
          >
            <svg width="32" height="32" fill="#1A3558" viewBox="0 0 24 24">
              <polygon points="5,3 19,12 5,21" />
            </svg>
          </Center>
        </Flex>
      </Box>

      {/* Subtitle */}
      <Text mt="8" textAlign="center" fontSize="lg" color="gray.700">
        <Text as="span" fontWeight="semibold" color="#1A3558">
          2-minute walkthrough
        </Text>{" "}
        — <Text as="span" color="gray.600">see how manufacturers use this</Text>
      </Text>
    </Box>
  );
};

export default VideoSection;